/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { MtaLearningProductInformationDTO } from '@mta/vela-api-types'
import { useHydrateAtoms } from 'jotai/utils'
import React from 'react'
import { productsAtom } from '@/store/basket'

/** A description of the available properties for this component. */
type BasketProductHydrationProps = {
  /** The manual information to use. */
  products: Array<MtaLearningProductInformationDTO>
}

/**
 * Component that hydrates the atom containing all the products, required for the basket overview.
 */
const BasketProductHydration: React.FC<BasketProductHydrationProps> = ({ products }) => {
  useHydrateAtoms([[productsAtom, products]])
  return null
}

export { BasketProductHydration }
